import { css, NativeTextFieldConfig } from '@sail/ui';
export const nativeTextFieldCustomization = NativeTextFieldConfig.customize({
    variants: {
        size: {
            medium: css({
                paddingX: 'space.150',
                paddingY: 'small'
            }),
            large: css({
                paddingX: 'medium',
                paddingY: 'space.150'
            })
        }
    }
});

//# sourceMappingURL=nativeTextField.js.map